<template>
  <router-view />
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  components: {
  },
  // props: {
  //   pid: {
  //     type: String,
  //     required: true
  //   }
  // },
  data () {
    return {}
  },
  computed: {
    ...mapState('project', ['project', 'isNeedCost']),
    pid () {
      return this.$store.state.pid || this.$route.params.pid
    }
  },
  watch: {
    pid (pid) {
      this.init()
    },
    isNeedCost: {
      handler (val) {
        if (val) {
          const month = new Date().getMonth() !== 0 ? new Date().getMonth() : 12
          const that = this
          if (this.$route.name !== 'CostMaintainDetail' && this.$route.name !== 'CostMaintain') {
            this.$confirm({
              title: <div>{month}{this.$t('message["1533"]')}</div>,
              closable: false,
              width: 425,
              centered: true,
              iconType: 'exclamation-circle',
              okText: this.$t('message["903"]'),
              cancelText: this.$t('message["1005"]'),
              onOk () {
                that.$router.push({
                  name: 'CostMaintain'
                })
              },
              onCancel () {
                that.cacelCostDialog()
              }
            })
          }
        }
      },
      immediate: true
    }
  },
  async beforeDestroy () {
    // await this.setPid('')
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions('project', ['setPid', 'fetchDatas']),
    ...mapActions('costMaintain/costIndexData', ['cacelCostDialog']),
    async init () {
      await this.setPid(this.pid)
      const chain = await this.fetchDatas()
      chain
        .params({
          id: this.pid
        })
        .fetch()
    }
    /* setRightHeight () {
      this.$nextTick(() => {
        if (!this.$refs.sectionMain) return

        this.$refs.sectionMain.style.minHeight = this.$refs.sectionMain.parentNode.offsetHeight + 'px'
      })
    } */
  }
}
</script>
